/**
 * localStorage-based cache for the admin dashboard.
 * Enables stale-while-revalidate: show cached data instantly, refresh in background.
 * Falls back silently if localStorage is unavailable (private mode, quota exceeded).
 */
const PREFIX = "dashboard_";

/**
 * @param {string} key
 * @param {any} value
 */
export function cacheSet(key, value) {
    try {
        localStorage.setItem(
            PREFIX + key,
            JSON.stringify({ value, cachedAt: Date.now() })
        );
    } catch (_) {
        // Ignore write failures (quota exceeded, private mode)
    }
}

/**
 * @param {string} key
 * @param {number} maxAgeMs - Return null if entry is older than this
 * @returns {{ value: any, cachedAt: number } | null}
 */
export function cacheGet(key, maxAgeMs) {
    try {
        const raw = localStorage.getItem(PREFIX + key);
        if (!raw) return null;
        const entry = JSON.parse(raw);
        if (Date.now() - entry.cachedAt > maxAgeMs) return null;
        return entry;
    } catch (_) {
        return null;
    }
}
